module.exports = __webpack_public_path__ + "static/media/FreddyLaugh1.74fb79b7.mp3";